import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    IconButton,
} from "@mui/material";
import T from "prop-types";
import { CloseOutlined } from "@ant-design/icons";
import { styled } from "@mui/material/styles";

const Transition = React.forwardRef((props, ref) => (
    <Slide direction="up" ref={ref} {...props} />
));

const StyledDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: "8px",
    },
    "& .MuiDialogActions-root": {
        gap: theme.spacing(1),
        marginLeft: "0 !important",
    },
    "& .MuiDialogTitle-root.MuiTypography-root": {
        fontSize: 16,
        fontWeight: "bold",
    },
}));

const ConfirmationModal = ({
    isOpen = false,
    renderActions,
    closeIcon = false,
    onClose,
    title,
    children,
    className,
    maxWidth = "xs",
    ...props
}) => (
    <StyledDialog
        open={isOpen}
        transition={Transition}
        keepMounted
        className={`confirmation-dialog ${className}`}
        fullWidth={true}
        maxWidth={maxWidth}
        onClose={onClose}
        {...props}
    >
        <DialogTitle align="center">
            <>
                {title}
                {closeIcon ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            left: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseOutlined />
                    </IconButton>
                ) : null}
            </>
        </DialogTitle>
        <DialogContent align="center">{children}</DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
            {renderActions()}
        </DialogActions>
    </StyledDialog>
);

ConfirmationModal.propTypes = {
    renderActions: T.func.isRequired,
    isOpen: T.bool.isRequired,
    title: T.string.isRequired,
    onClose: T.func.isRequired,
    children: T.any,
    closeIcon: T.bool,
    className: T.string,
    maxWidth: T.string,
};

export default ConfirmationModal;
